import * as React from 'react';
import type { SVGProps } from 'react';
const SvgWithdrawal = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={40} height={41} fill='none' {...props}>
    <rect width={40} height={40} y={0.5} fill='#FF4081' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='m17.32 15 2.56-2.56L22.44 15M19.88 22.68V12.51M12 20.5c0 4.42 3 8 8 8s8-3.58 8-8'
    />
  </svg>
);
export default SvgWithdrawal;
